module.exports = __webpack_public_path__ + "static/media/payroll-icon.a9ec6b4c.svg";